import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Todos from "../../../todos/components/Todos/Todos";
import useTodos from "../../../todos/hooks/useTodos";

import HomeLayout from "../../layouts/HomeLayout/HomeLayout";

import TodoClearFiltersIcon from "./components/TodoClearFiltersIcon";
import TodoOrderIcon from "./components/TodoOrderIcon";
import TodoResolvedIcon from "./components/TodoResolvedIcon";
import TodoTypeDropdown from "./components/TodoTypeDropdown";
import TodoUserDropdown from "./components/TodoUserDropdown";

export default function TodosWidget({ organization, language }) {
	const { t } = useTranslation();

	const [productionLanguage, setProductionLanguage] = useState(null);
	const [type, setType] = useState(null);
	const [userId, setUserId] = useState(null);
	const [order, setOrder] = useState("desc");
	const [showResolved, setShowResolved] = useState(false);

	const { sortedTodos, filteredTodos, loading, error } = useTodos({
		productionLanguage: language,
		type,
		order,
		showResolved,
		userId,
		organization,
	});

	const activeFilters = productionLanguage || type || userId || order === "asc" || showResolved;

	const onClear = () => {
		setProductionLanguage(null);
		setType(null);
		setUserId(null);
		setOrder("desc");
		setShowResolved(false);
	};

	return (
		<HomeLayout.Widget
			icon="tasks"
			color="blue"
			header={t("todos", "Todos")}
			toolbar={
				<>
					<TodoTypeDropdown type={type} todos={sortedTodos} onClick={setType} />

					{organization && <TodoUserDropdown userId={userId} todos={sortedTodos} onClick={setUserId} />}

					<TodoResolvedIcon showResolved={showResolved} onClick={() => setShowResolved(!showResolved)} />

					<TodoOrderIcon
						order={order}
						onClick={() => setOrder((order) => (order === "desc" ? "asc" : "desc"))}
					/>

					<TodoClearFiltersIcon onClick={onClear} active={activeFilters} />
				</>
			}
		>
			<Todos
				todos={filteredTodos}
				organization={organization}
				language={language}
				loading={loading}
				error={error}
			/>
		</HomeLayout.Widget>
	);
}
